<template>
  <div id="app">
    <div v-if="autoClosed"
      class="network-prompt">
      <i class="iconfont">&#xe6fa;</i>当前网络不可用，请检查您的网络设置!</div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!--<router-view></router-view>-->
  </div>
</template>
<script>
import front from "../static/js/proto/CtpFront.js";
export default {
  name: "app",
  data() {
    return {};
  },
  computed: {
    autoClosed() {
      return this.$store.state.autoClosed;
    }
  }
};
</script>
<style lang="scss">
@import "~@/styles/zIndex.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.3rem;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(246, 97, 96);
}

.network-prompt {
  height: 0.8rem;
  line-height: 0.8rem;
  background: rgb(255, 223, 224);
  color: rgb(99, 82, 80);
  font-size: 0.28rem;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 1rem;
  z-index: $networkPrompt;
}
</style>





// WEBPACK FOOTER //
// src/App.vue